import { Skeleton } from "primereact/skeleton";

const SurveyTableSkeleton = () => {
  return (
    <>
      {Array.from({ length: 8 }).map((_, index) => (
        <tr key={index}>
          <td style={{ width: "4%", padding: "10px" }}>
            <Skeleton width="30px" height="14px" />
          </td>
          <td style={{ width: "15%", padding: "10px" }}>
            <Skeleton width="90%" height="14px" />
          </td>
          <td style={{ width: "15%", padding: "10px" }}>
            <Skeleton width="90%" height="14px" />
          </td>
          <td style={{ width: "8%", padding: "10px" }}>
            <Skeleton width="80%" height="14px" />
          </td>
          <td style={{ width: "10%", padding: "10px" }}>
            <Skeleton width="85%" height="14px" />
          </td>
          <td style={{ width: "12%", padding: "10px" }}>
            <Skeleton width="90%" height="14px" />
          </td>
          <td style={{ width: "12%", padding: "10px" }}>
            <Skeleton width="100px" height="14px" />
          </td>
          <td style={{ width: "17%", padding: "10px" }}>
            <Skeleton width="90%" height="14px" />
          </td>
          <td style={{ width: "10%", padding: "10px" }}>
            <Skeleton width="60px" height="30px" borderRadius="16px" />
          </td>
        </tr>
      ))}
    </>
  );
};

export default SurveyTableSkeleton;
